export interface ICompanyIcons {
  icon: string
  name: string
  lightIcon: string
}

export const techCompanyIcons: Array<ICompanyIcons> = [
  {
    icon: "/assets/icons/thumb.svg",
    lightIcon: "/assets/icons/thumb-light.svg",
    name: "Open & Respectful",
  },
  {
    icon: "/assets/icons/lock.svg",
    lightIcon: "/assets/icons/lock-light.svg",
    name: "Integrity & Honesty",
  },
  {
    icon: "/assets/icons/users.svg",
    lightIcon: "/assets/icons/users-light.svg",
    name: "Inclusion & Belonging",
  },
]
